import { createApi } from '@reduxjs/toolkit/query/react'
import { baseQueryWithReauth } from '../apiSlice'
import { ICreateChallengeInput, IGetChallenges, IGetChallengesData } from './model'
import { formDataCreate } from '../../../utils/formDataUpload/formDataUpload'
import { ISearchParams } from '../../../global.model'

export const challengeApi = createApi({
  reducerPath: 'challenge/Api',
  baseQuery: baseQueryWithReauth,
  endpoints: build => ({
    getChallenges: build.query<IGetChallenges, ISearchParams | void>({
      query: params => ({
        url: '/admin/challenge',
        method: 'GET',
        params: { ...params }
      })
    }),
    getChallengeById: build.query<IGetChallengesData, number>({
      query: (id: number) => ({
        url: `/admin/challenge/${id}`,
        method: 'GET'
      })
    }),
    createChallenge: build.mutation<{ message: string }, ICreateChallengeInput>({
      query: (challengeData: ICreateChallengeInput) => ({
        url: 'admin/challenge',
        method: 'POST',
        body: formDataCreate({ ...challengeData })
      })
    }),
    updateChallenge: build.mutation<void, ICreateChallengeInput>({
      query: (challenge: ICreateChallengeInput) => ({
        url: '/admin/challenge',
        method: 'PUT',
        body: formDataCreate({ ...challenge })
      })
    }),
    deleteChallenge: build.mutation<void, string>({
      query: (id: string) => ({
        url: `/admin/challenge/${id}`,
        method: 'DELETE'
      })
    })
  })
})

export const {
  useGetChallengesQuery,
  useGetChallengeByIdQuery,
  useCreateChallengeMutation,
  useUpdateChallengeMutation,
  useDeleteChallengeMutation
} = challengeApi
